import { render, staticRenderFns } from "./wong-baker-response.vue?vue&type=template&id=2f1f4320&scoped=true&"
import script from "./wong-baker-response.vue?vue&type=script&lang=js&"
export * from "./wong-baker-response.vue?vue&type=script&lang=js&"
import style0 from "./wong-baker-response.vue?vue&type=style&index=0&id=2f1f4320&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1f4320",
  null
  
)

component.options.__file = "wong-baker-response.vue"
export default component.exports